/**
 * 公告管理api
 */
export default {
  // 新增信息公告
  insertNoticeInfo: '/notice/insertNoticeInfo',
  // 查询所有信息公告
  selectNoticeInfoAllList: '/notice/selectNoticeInfoAllList',
  // 查询信息公告详情
  selectNoticeInfoDetail:'/notice/selectNoticeInfoDetail',
};
